
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { HttpException, HttpStatus, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Repository } from 'typeorm';
import { SupplierLoginDto } from './dto/supplier-login-dto';
import { SupplierCreationDto } from './dto/supplier-mapping.dto';
import { SupplierCreation } from './supplier-creation.entity';
import * as bcrypt from 'bcrypt'
import { JwtService } from '@nestjs/jwt';
import { JwtPayload } from './dto/jwt.payload';
import appSettings from 'apps/services/config';
import { ErrorResponse, SupplierMappingTypeEnum } from '@gtpl/shared-models/common-models';
import { SupplierThemeDto } from './dto/supplier-theme-dto';


@Injectable()
export class SupplierMappingService {
  constructor(
    @InjectRepository(SupplierCreation)
    private readonly userRepo: Repository<SupplierCreation>,
    private jwtService: JwtService
  ) { }



  async create(userDto: SupplierCreationDto): Promise<CommonResponse> {
    const { supplierType, supplierId, userName, password } = userDto;
    // check if the user exists in the db    
    const userInDb = await this.userRepo.findOne({
      where: { userName: userName }
    });
    if (userInDb) {
      throw new HttpException('UserName already exists', HttpStatus.BAD_REQUEST);
    }
    console.log(userDto)
    const newUserDto = new SupplierCreation()
    newUserDto.supplierId = userDto.supplierId;
    newUserDto.supplierType = userDto.supplierType
    newUserDto.userName = userDto.userName
    newUserDto.password = userDto.password
    const createUser: SupplierCreation = await this.userRepo.create(newUserDto)
    await this.userRepo.save(createUser)
    return new CommonResponse(true, 1111, 'created sucessfully')
  }

  async login(req: SupplierLoginDto): Promise<CommonResponse> {
    try {
      console.log(req)
      const userAuth = await this.userRepo.findOne({ where: { userName: req.userName } })
      console.log(userAuth)
      if (!userAuth) return new CommonResponse(false, 11111, 'Username not exist');
      if (!(await bcrypt.compare(req.password, userAuth.password))) return new CommonResponse(false, 11111, 'Password is incorrect');
      let query
      console.log(userAuth)
      if (userAuth.supplierType == SupplierMappingTypeEnum.PackingSupplier) {
        query = `select vendor_name as userName from ` + appSettings.masters_db + `.vendors where vendor_id = ` + userAuth.supplierId
      } else if (userAuth.supplierType == SupplierMappingTypeEnum.EndCustomer) {
        query = `select end_customer_name as userName from ` + appSettings.masters_db + `.end_customers where end_customer_id = ` + userAuth.supplierId
      }
      const data = await getManager().query(query)
      const user: any = { userName: userAuth.userName, supplierType: userAuth.supplierType, supplierId: userAuth.supplierId, supplierName: data[0].userName,isDarkMode : userAuth.isDarkMode,primaryColor : userAuth.primaryColor,borderRadius : userAuth.borderRadius }
      console.log(user)
      const accessToken = this.jwtService.sign(user,{expiresIn:"1h"});
      return new CommonResponse(true, 11111, 'Login Sucessfull', accessToken)
    } catch (error) {
      console.log(error)
      return error
    }
  }

  async getRegisteredSuppliers(): Promise<CommonResponse> {
    try {
      const usersData = await this.userRepo.find();
      return new CommonResponse(true, 11111, 'Data Retreived', usersData)
    } catch (error) {
      throw error
    }

  }

  async updatePassword(dto:SupplierLoginDto):Promise<CommonResponse>{
    try{
        const userData = await this.userRepo.update({userName:dto.userName},{password:dto.password})
        if(userData.affected){
          return new CommonResponse(true, 11111, 'Password updated sucessfully')
        }else{
          return new CommonResponse(false, 11111, 'Error while updating password')

        }
    }catch(error){
       throw new ErrorResponse(12111,error)
    }
  }

  async updateUserTheme(dto : SupplierThemeDto) : Promise<CommonResponse>{
      const updateTheme = await this.userRepo.update({supplierId : dto.supplierId},{borderRadius:dto.borderRadius,isDarkMode : dto.isDarkMode,primaryColor:dto.primaryColor})
      if(updateTheme.affected){
        return new CommonResponse(true,11111,'Theme Updated')
      }else{
        return new CommonResponse(false, 11111, 'Error while updating theme')      }
  }

  async addProfilePhoto(filesData: any[], id: number) {
    const savedData = await this.userRepo.update({ supplierId : id }, {
      file: filesData[0].file,
      filePath: filesData[0].filePath
    });
    const filePath = await this.userRepo.findOne({ where: { supplierId: id }, select: ['filePath'] })
    return new CommonResponse(true, 20, 'Profile Data update SuccessFully', filePath);
  }


}

